module.exports = __webpack_public_path__ + "img/logo-MOEV.70079364.png";